// Libs
import React, { useState } from 'react';
import styled from 'styled-components';
// Components
import { Button, LogoIcon, Span } from 'components';
// Services
import { ApiServiceV2 } from 'services';

const HoverCell = styled.div`
	padding: 0;
	width: 100%;
	display: grid;
	align-items: center;

	& > * { grid-area: 1 / 1; display: flex; align-items: center; }

	.applied-action { visibility: hidden; pointer-events: none; }

	&:hover .applied-default { visibility: hidden; pointer-events: none; }
	&:hover .applied-action { visibility: visible; pointer-events: auto; }
`;

const AppliedSelected = ({ isPaymentId, rowData, refreshRowData }) => {
	const [isFetching, setIsFetchin] = useState(false);

	const handdleOnClick = e => {
		e.stopPropagation();
		setIsFetchin(true);

		ApiServiceV2.put({
			url: '/payments_lines/line',
			data: {
				line_id: rowData.id,
				assign_in: isPaymentId ? null : rowData.mainPaymentId,
				payment_id: rowData.mainPaymentId,
				paycut_id: rowData.paycut_id,
			},
		})
			.then(() => refreshRowData({ elementId: rowData.id }))
			.then(() => setIsFetchin(false))
			.catch(() => setIsFetchin(false));
	};

	return isFetching ? (
		<LogoIcon spin button />
	) : (
		<Button width='100%' onClick={handdleOnClick}>
			{isPaymentId ? 'Quitar' : 'Aplicar'}
		</Button>
	);
};

const Applied = ({ field, rowData }) => {
	const isPaymentId = !!rowData.payment_id;
	const canInteract =
		field.canManageLines !== false &&
		field.canManageOrders !== false &&
		!rowData.isPaymentSigned &&
		rowData.isPaymentOpen;

	return (
		<HoverCell>
			<span className='applied-default'>
				<Span>{isPaymentId ? rowData.payment_id : 'No'}</Span>
			</span>
			{canInteract && (
				<span className='applied-action'>
					<AppliedSelected
						isPaymentId={isPaymentId}
						rowData={rowData}
						refreshRowData={field.refreshRowData}
					/>
				</span>
			)}
		</HoverCell>
	);
};
export default Applied;
